export default __webpack_public_path__ + "static/media/jain.870a280b4e50384404821c677e966a40.png";